import React from 'react';
import { Link } from 'react-router-dom';
import { X, BarChart3 } from 'lucide-react';
import { useCompare } from '../context/CompareContext';

export default function CompareBar() {
  const { items, removeFromCompare } = useCompare();

  if (items.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-2xl" data-testid="compare-bar">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 overflow-x-auto">
          {items.map(p => (
            <div key={p.slug} className="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-1.5 shrink-0">
              <img src={p.imageUrl} alt={p.name} className="w-8 h-8 rounded object-cover" />
              <span className="text-xs font-semibold text-gray-700 max-w-[120px] truncate">{p.name}</span>
              <button
                onClick={() => removeFromCompare(p.slug)}
                className="text-gray-400 hover:text-red-500 transition-colors"
                data-testid={`compare-bar-remove-${p.slug}`}
              >
                <X size={12} />
              </button>
            </div>
          ))}
          {items.length < 3 && (
            <span className="text-xs text-gray-400 shrink-0">
              Add {3 - items.length} more
            </span>
          )}
        </div>
        <Link
          to="/compare"
          className={`flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-sm font-bold transition-colors shrink-0 ${
            items.length >= 2
              ? 'bg-green-600 text-white hover:bg-green-700'
              : 'bg-gray-200 text-gray-400 cursor-not-allowed pointer-events-none'
          }`}
          data-testid="compare-bar-cta"
        >
          <BarChart3 size={14} /> Compare ({items.length})
        </Link>
      </div>
    </div>
  );
}
